import { logError } from '@mop/shared/utils/logger';

// Leaving debug code for future reference

// let totalTime = 0;
// let callCount = 0;
// let wrappedCount = 0;
// let debugTimer: ReturnType<typeof setTimeout>;

export function securedWrap<T>(item: T): T {
  // const start = performance.now();
  // callCount++;
  for (const key of Object.keys(item as object)) {
    const callbackFn = (item as any)[key];
    if (typeof callbackFn !== 'function') {
      continue;
    }

    // wrappedCount++;
    const wrapper = function (...args: any) {
      try {
        const value = callbackFn.apply(item, args);
        if (value instanceof Promise) {
          return value.catch(logError);
        }
        return value;
      } catch (error) {
        logError(error);
      }
    };
    (item as any)[key] = wrapper;
  }

  // totalTime += performance.now() - start;
  // clearTimeout(debugTimer);
  // debugTimer = setTimeout(() => {
  // console.log(`[securedWrap] total: ${totalTime.toFixed(2)}ms | calls: ${callCount} | wrapped: ${wrappedCount}`);
  // }, 3000);

  return item;
}

/**
 * Use this if you need to debug composable invocations, counts and test for possible optimizations

import { logError } from '@mop/shared/utils/logger';

const SECURED = Symbol('secured');

let totalTime = 0;
let callCount = 0;
let wrappedCount = 0;
let skippedCount = 0;
let debugTimer: ReturnType<typeof setTimeout>;

const composableStats: Record<string, { calls: number; wrapped: number; skipped: number }> = {};
const invocationStats: Record<string, number> = {};

function getCaller(): string {
  const stack = new Error().stack || '';
  const lines = stack.split('\n');
  // Skip: Error, securedWrap, securedWrap caller → find the composable
  for (let i = 2; i < lines.length; i++) {
    const line = lines[i];
    const match = line.match(/at\s+(\S+)/);
    if (match && !match[1].includes('securedWrap')) {
      return match[1].replace(/^Object\./, '');
    }
  }
  return 'unknown';
}

function logStats() {
  console.log(
    `[securedWrap] total: ${totalTime.toFixed(
      2,
    )}ms | calls: ${callCount} | wrapped: ${wrappedCount} | skipped: ${skippedCount}`,
  );

  const sorted = Object.entries(composableStats).sort(([, a], [, b]) => b.calls - a.calls);
  console.table(
    sorted.reduce(
      (acc, [name, stats]) => {
        acc[name] = stats;
        return acc;
      },
      {} as Record<string, { calls: number; wrapped: number; skipped: number }>,
    ),
  );

  const invSorted = Object.entries(invocationStats)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 30);
  if (invSorted.length) {
    console.log('[securedWrap] top 30 invoked functions:');
    console.table(
      invSorted.reduce(
        (acc, [name, count]) => {
          acc[name] = { invocations: count };
          return acc;
        },
        {} as Record<string, { invocations: number }>,
      ),
    );
  }
}

export function securedWrap<T>(item: T): T {
  if ((item as any)[SECURED]) {
    return item;
  }
  const start = performance.now();
  callCount++;
  (item as any)[SECURED] = true;
  const caller = getCaller();
  const stat = composableStats[caller] || (composableStats[caller] = { calls: 0, wrapped: 0, skipped: 0 });
  stat.calls++;
  const keys = Object.keys(item as object);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const callbackFn = (item as any)[key];
    if (typeof callbackFn !== 'function' || (callbackFn as any)[SECURED]) {
      if (typeof callbackFn === 'function') {
        skippedCount++;
        stat.skipped++;
      }
      continue;
    }

    wrappedCount++;
    stat.wrapped++;
    const invKey = `${caller}.${key}`;
    const wrapper = function (...args: any) {
      invocationStats[invKey] = (invocationStats[invKey] || 0) + 1;
      try {
        const value = callbackFn.apply(item, args);
        if (value instanceof Promise) {
          return value.catch(logError);
        }
        return value;
      } catch (error) {
        logError(error);
      }
    };
    (wrapper as any)[SECURED] = true;
    (item as any)[key] = wrapper;
  }

  totalTime += performance.now() - start;
  clearTimeout(debugTimer);
  debugTimer = setTimeout(logStats, 3000);

  return item;
}
 */
